export default {
  BusinessStockDistributionPlan: {
    header: {
      code: 'Sub-warehouse plan number',
      receiveWarehouseIdList: 'Receiving Warehouse',
    },
    page: 'Non-review Page',
    pageText1: 'Can be modified under the pending audit status, click to jump to modify the sub-warehouse plan form, and the current sub-warehouse plan information will be automatically filled in',
    pageText2: 'Can be reset under the rejected audit and cancelled status, after resetting, the sub-warehouse plan automatically becomes the pending audit status',
    pageText3: 'In-progress sub-warehouse plans can be cancelled. After cancellation, the plan will no longer be executed and the status will be changed to cancelled',
    btn: 'Void',
    pageText4: 'Can be cancelled under the pending audit status. Click to confirm whether to cancel the selected sub-warehouse plan. After confirming the cancellation, the selected sub-warehouse plan will be cancelled',
    reset: 'Reset',
    warehousePlan: 'Sub-warehouse Plan',

    table: {
      code: 'Plan Number',
      receiveWarehouseName: 'Receiving Warehouse',
      planNum: 'Planned Supply Quantity',
      alreadyNum: 'Quantity Supplied',
      priorityGrade: 'Priority',
    }
  }
};
